<template>
  <section class="dashboard-card vessel-map-card">
    <h3>Map of Vessel Movements</h3>

    <div class="map-placeholder">
      Map placeholder
    </div>

    <ul class="map-notes">
      <li>Map should contain the areas of underperformance</li>
      <li>Present each maintenance event separately or all together</li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "VesselMovementMap"
};
</script>

<style scoped>
.dashboard-card {
  background: var(--color-primary);
  border: 1px solid #dbe3ef;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.dashboard-card h3 {
  margin: 0 0 14px;
  color: #0f172a;
  font-size: 18px;
}

.map-placeholder {
  height: 260px;
  border-radius: 14px;
  background: linear-gradient(135deg, #dbeafe, #ecfeff);
  border: 1px dashed #0284c7;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #075985;
  font-weight: 700;
}

.map-notes {
  margin: 14px 0 0;
  padding-left: 18px;
  color: #475569;
  font-size: 14px;
}
</style>
